import { atom } from "recoil";

export const selectedKeywordState = atom({
  key: "selectedKeywordState",
  default: "",
});
